import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { href: '/', label: 'Home' },
  { href: '/services', label: 'Services' },
  { href: '/industries', label: 'Industries' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/80 backdrop-blur-xl border-b border-black/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img
            src="https://public.readdy.ai/ai/img_res/d6ab1378-0b1c-45b1-a3cd-1269214cedf2.png"
            alt="Omega Solutions AI"
            className="w-[90px] h-[90px] object-contain"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer tracking-tight ${
                scrolled
                  ? location.pathname === link.href
                    ? 'text-[#0A0A0A]'
                    : 'text-[#6E6E73] hover:text-[#0A0A0A]'
                  : location.pathname === link.href
                  ? 'text-white'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/services"
            className={`whitespace-nowrap text-sm font-semibold px-5 py-2 rounded-full transition-all duration-200 cursor-pointer ${
              scrolled
                ? 'bg-[#0A0A0A] text-white hover:bg-[#1D1D1F]'
                : 'bg-white/15 text-white border border-white/30 hover:bg-white/25 backdrop-blur-sm'
            }`}
          >
            Get Audit
          </Link>
        </div>

        <button
          className={`md:hidden p-2 rounded-lg cursor-pointer ${
            scrolled ? 'text-[#0A0A0A]' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-black/5 px-6 py-5 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-sm font-medium text-[#1D1D1F] hover:text-black cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/services"
            onClick={() => setMenuOpen(false)}
            className="whitespace-nowrap bg-[#0A0A0A] text-white text-sm font-semibold px-5 py-2.5 rounded-full text-center cursor-pointer"
          >
            Get Audit
          </Link>
        </div>
      )}
    </nav>
  );
}
